import type { HighlightBarStyle } from '@/components/admin/HighlightBarStyleEditor';
import { HIGHLIGHT_BAR_STYLE_DEFAULTS, HIGHLIGHT_BAR_STYLE_KEY } from '@/components/admin/HighlightBarStyleEditor';

export { HIGHLIGHT_BAR_STYLE_KEY, HIGHLIGHT_BAR_STYLE_DEFAULTS };
export type { HighlightBarStyle };

const HEX_RE = /^#[0-9A-Fa-f]{6}$/;

export const hexToRgba = (hex: string, alpha: number): string => {
  if (!HEX_RE.test(hex)) return `rgba(239, 68, 68, ${alpha})`;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const resolveHighlightStyle = (
  raw: Partial<HighlightBarStyle> | undefined | null
): HighlightBarStyle => ({ ...HIGHLIGHT_BAR_STYLE_DEFAULTS, ...(raw || {}) });
